<fcom-selectable-card
  testId="change-flight-select"
  [inputId]="'bound-selection-item-' + bound.id"
  [checked]="isSelected"
  [disabled]="disabled"
  [describedBy]="bound?.id"
  (selectionChange)="onSelectionChange()"
>
  <fcom-selectable-card-header>
    <h2 class="font-heading-5 font-body-medium">
      {{
        (isDeparture
          ? 'MMB.voluntaryChange.phases.selectBounds.departure.heading'
          : 'MMB.voluntaryChange.phases.selectBounds.return.heading'
        ) | finLocalization
      }}
    </h2>
    <span class="flex flex--middle flex--nogrow">
      <fcom-icon
        class="icon-small ms-xxsmall-r"
        [name]="passengerCount > 1 ? SvgLibraryIcon.MULTI_PAX : SvgLibraryIcon.SINGLE_PAX"
      />
      <span>{{ passengerCount }}</span>
    </span>
  </fcom-selectable-card-header>

  <fcom-selectable-card-content>
    <div class="font-body-1 nordic-blue-900-text medium-type">
      {{ bound?.departure?.dateTime | finDateFormat: 'EE d MMM yyyy' }}
    </div>
    <div id="{{ bound.id }}">
      <fcom-ufo
        [arrival]="getLocation(bound.arrival) | async"
        [departure]="getLocation(bound.departure) | async"
        [tails]="tails | finTailNames"
        [airlines]="bound.uniqueAirlineNames"
        [duration]="bound.duration | finDuration | async"
        [stops]="bound.stops"
        [showViewDetails]="false"
        [attr.id]="bound.id"
        [flightNumbers]="bound.itinerary | finFlightNumbers"
      />
    </div>
    @if (bound.cabinClass) {
      <div class="flex">
        <fcom-tag>{{ 'travelClass.' + bound.cabinClass.toLowerCase() | finLocalization }}</fcom-tag>
      </div>
    }
    @if (notification) {
      <fcom-notification class="fill pr-small-t" [layout]="NotificationLayout.BLOCK">
        {{ notification | finLocalization }}
      </fcom-notification>
    }
  </fcom-selectable-card-content>
</fcom-selectable-card>
